import { render, staticRenderFns } from "./ReposicionTarjeta.vue?vue&type=template&id=0a503bb8&scoped=true"
import script from "./ReposicionTarjeta.vue?vue&type=script&lang=js"
export * from "./ReposicionTarjeta.vue?vue&type=script&lang=js"
import style0 from "./ReposicionTarjeta.vue?vue&type=style&index=0&id=0a503bb8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a503bb8",
  null
  
)

export default component.exports